import { service } from '../../api/axios';

export type TNotification = {
  _id: string;
  userId: string;
  type: string;
  title?: string;
  content: string;
  timestamp: Date;
  readStatus: boolean;
  priorityLevel?: string;
  sourceId?: string;
  actionUrl?: string;
  expirationTime?: Date;
  metadata?: Record<string, any>;
};

export const getNotifications = async () => {
  const response = await service.get<TNotification[]>('/notifications', {});
  return response.data;
};
